export const gcd = (a, b) => (b ? gcd(b, a % b) : Math.abs(a));
export const lcm = (a, b) => Math.abs(a * b) / gcd(a, b);
export const lcmOfSet = (xs) => xs.reduce((acc, n) => lcm(acc, n), 1);
